import FacilityProfileV2 from 'model/facilities/facilityProfileV2';
export var DEFAULT_TITLE = 'Type';
export var getReadableTitle = function (arr) {
    var result = '';
    if (!arr || !(arr === null || arr === void 0 ? void 0 : arr.length))
        return DEFAULT_TITLE;
    result = FacilityProfileV2.getLocationType(arr[0]);
    if (arr.length > 1)
        result += " + ".concat(arr.length - 1);
    return result;
};
